var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShaggyHighlighted({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.039,
    height: 59.748,
    viewBox: "0 0 53.039 59.748",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29400",
    "data-name": "Group 29400",
    transform: "translate(-489 -262.165)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-7_20_",
    "data-name": "svgexport-7 (20)",
    transform: "translate(489 262.165)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48766",
    "data-name": "Path 48766",
    d: "M76.459,46.592a.961.961,0,1,1,.9-1.7,11.014,11.014,0,0,1,3.2,2.393,4.54,4.54,0,0,1,1.231,2.987c0,2.811-3.113,5.254-8.148,6.93a60.509,60.509,0,0,1-18.371,2.546A60.5,60.5,0,0,1,36.9,57.2c-5.035-1.676-8.148-4.119-8.148-6.93a4.544,4.544,0,0,1,1.231-2.987,11.015,11.015,0,0,1,3.2-2.393.961.961,0,1,1,.9,1.7,9.161,9.161,0,0,0-2.643,1.949,2.689,2.689,0,0,0-.757,1.73c0,1.89,2.609,3.7,6.824,5.108a58.6,58.6,0,0,0,17.769,2.44,58.606,58.606,0,0,0,17.77-2.44c4.216-1.4,6.823-3.217,6.823-5.107a2.687,2.687,0,0,0-.757-1.73,9.144,9.144,0,0,0-2.643-1.949ZM48.677,43.021a24.169,24.169,0,0,0-6.952,1.915c-1.483.729-2.35,1.52-2.35,2.284,0,1.09,1.634,2.179,4.274,3.058a38.326,38.326,0,0,0,11.618,1.592,38.324,38.324,0,0,0,11.618-1.592c2.641-.88,4.275-1.969,4.275-3.058,0-.764-.866-1.555-2.351-2.284a24.166,24.166,0,0,0-6.951-1.915,35.368,35.368,0,0,1-6.087,4.956.959.959,0,0,1-1.028-.012,35.482,35.482,0,0,1-6.067-4.944ZM55.267,8.5a10.049,10.049,0,1,1-7.107,2.943A10.049,10.049,0,0,1,55.267,8.5Zm5.744,4.306a8.122,8.122,0,1,0,2.379,5.743,8.122,8.122,0,0,0-2.379-5.743ZM49.977,41.6a34.97,34.97,0,0,0,5.29,4.425,35.047,35.047,0,0,0,5.29-4.423A46.03,46.03,0,0,0,71.012,25.761c2.178-5.913,2.527-12.143-.78-17.476a18.044,18.044,0,0,0-2.6-3.245,17.69,17.69,0,0,0-24.732,0,18.044,18.044,0,0,0-2.6,3.245c-3.307,5.333-2.958,11.563-.779,17.476A46.009,46.009,0,0,0,49.977,41.6Z",
    transform: "translate(-28.748 0)",
    fill: "#1a74e2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_284",
    "data-name": "Ellipse 284",
    cx: 15.884,
    cy: 15.884,
    r: 15.884,
    transform: "translate(10.685 1.444)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_29399",
    "data-name": "Group 29399",
    transform: "translate(507.602 268.359)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50296",
    "data-name": "Path 50296",
    d: "M21.43,40,21,43.442h2.581l.43-3.011Z",
    transform: "translate(-14.547 -22.792)",
    fill: "#efad60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50297",
    "data-name": "Path 50297",
    d: "M16.151,12.883S14,12.883,14,15.895c0,.86.43,2.581,2.151,2.151.43,3.011,1.761,5.257,5.162,4.732,2.787-.43,3.145-2.291,2.993-3.643-.165-1.464-.865-7.126.018-10.123C25.094,6.4,20.453,6,20.453,6L16.581,9.872Z",
    transform: "translate(-10.559 -3.419)",
    fill: "#ffcc80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50298",
    "data-name": "Path 50298",
    d: "M9.872,4.732S6.43,3.872,6,11.615c.86-1.291,1.291-1.291,1.291-1.291s-1.073,6.357,5.27,7.245a8.05,8.05,0,0,1-.68-3.3s-2.009.353-2.009-2.228a4.45,4.45,0,0,1,.43-1.721,5.415,5.415,0,0,0,1.721,3.011c1.291-2.151.43-6.453.43-6.453s3.442-.86,4.3-2.151c0,1.721-.43,2.151-.43,2.151A7.547,7.547,0,0,0,19.707,5.73c-.8,1.584-.371,6.316-.371,6.316s2.581-3.011,1.291-6.453C24.068,3.011,19.336,0,16.755,0S9.872,1.721,9.872,4.732Z",
    transform: "translate(-6)",
    fill: "#a07416"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50299",
    "data-name": "Path 50299",
    d: "M23.117,29.973s.968,1.38,2.265,1.112a6.006,6.006,0,0,1,2.451-.1c.453.083.638-.1.906-.536.34.813-.618,1.256-.947,1.236a9.166,9.166,0,0,0-2.327.35A2,2,0,0,1,23.117,29.973Z",
    transform: "translate(-15.754 -17.079)",
    fill: "#efad60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50300",
    "data-name": "Path 50300",
    d: "M26.521,21.939a2.109,2.109,0,0,0,2.357,1.226,1.394,1.394,0,0,0,1.176-1.927c-.329-.644-1.291-1.236-1.332-2.018a2.714,2.714,0,0,1,.227-1.215,2.427,2.427,0,0,0-.638,1.421c-.021.783.753,1.475.92,1.963C29.6,22.475,27.707,22.763,26.521,21.939Z",
    transform: "translate(-17.693 -10.26)",
    fill: "#efad60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50301",
    "data-name": "Path 50301",
    d: "M25.718,15.246c-.309-.432-1.771-1.153-2.409,1.153A2.45,2.45,0,0,1,25.718,15.246Z",
    transform: "translate(-15.863 -8.427)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50302",
    "data-name": "Path 50302",
    d: "M33.928,16.6a1.162,1.162,0,0,0-1.38-.247C33.063,15.389,33.887,15.7,33.928,16.6Z",
    transform: "translate(-21.127 -8.982)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_481",
    "data-name": "Ellipse 481",
    cx: 0.43,
    cy: 0.43,
    rx: 0.43,
    ry: 0.43,
    transform: "translate(8.603 8.604)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_482",
    "data-name": "Ellipse 482",
    cx: 0.43,
    cy: 0.43,
    rx: 0.43,
    ry: 0.43,
    transform: "translate(11.615 8.604)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShaggyHighlighted);
export default __webpack_public_path__ + "static/media/shaggyHighlighted.0b6c5a44f820ccbd2c863181e8dd9a9f.svg";
export { ForwardRef as ReactComponent };